<fd-select
  (selectionChange)="onChange(formGroup.value.category)"
  [parentForm]="formGroup"
  [field]="field"
></fd-select>
